import { State } from '../../types';

export const alabama: State = {
  name: 'Alabama',
  abbreviation: 'AL',
  terms: [
    {
      word: 'Arab',
      phonetic: 'AY-rab',
      // audioUrl: '/audio/arab.mp3',
      description: 'City in northern Alabama'
    },
    {
      word: 'Cahaba',
      phonetic: 'kuh-HAW-buh',
      // audioUrl: '/audio/arab.mp3',
      description: 'The first capital of Alabama, often mispronounced as "KAY-hah-bah."'
    },
    {
      word: 'Cairo',
      phonetic: 'KAY-row',
      // audioUrl: '/audio/cairo.mp3',
      description: 'An unincorporated community pronounced like the white cooking syrup, not the Egyptian city.'
    },
    {
      word: 'Cleburne',
      phonetic: 'KLEE-burn',
      // audioUrl: '/audio/cleburne.mp3',
      description: 'County named for Maj. Gen. Patrick R. Cleburne, often mispronounced as "Clay-burn."'
    },
    {
      word: 'Conecuh',
      phonetic: 'cah-NECK-ah',
      // audioUrl: '/audio/conecuh.mp3',
      description: 'Derived from a Creek Indian word meaning "land of cane."'
    },
    {
      word: 'Eufaula',
      phonetic: 'yoo-FALL-uh',
      // audioUrl: '/audio/arab.mp3',
      description: 'A city in southeastern Alabama, commonly mispronounced as "YOU-fah-lah."'
    },
    {
      word: 'Flomaton',
      phonetic: 'Flow-ma-tahn',
      // audioUrl: '/audio/flomaton.mp3',
      description: 'A town whose name combines "Florida," "Alabama," and "town."'
    },
    {
      word: 'Guin',
      phonetic: 'Gyoo-win',
      // audioUrl: '/audio/guin.mp3',
      description: 'A town named for a pioneering family, often mispronounced as "goo" or "jew."'
    },
    {
      word: 'LaFayette',
      phonetic: 'La-FAY-it',
      // audioUrl: '/audio/lafayette.mp3',
      description: 'Town named for the Marquis de Lafayette, emphasizing the second syllable.'
    },
    {
      word: 'Loachapoka',
      phonetic: 'LOW-cha-POH-Kah',
      // audioUrl: '/audio/arab.mp3',
      description: 'A town in Lee county Alabama.'
    },
    {
      word: 'Mobile',
      phonetic: 'moh-BEEL',
      // audioUrl: '/audio/mobile.mp3',
      description: 'Major city in southern Alabama'
    },
    {
      word: 'Oneonta',
      phonetic: 'Oh-nee-ON-ta',
      // audioUrl: '/audio/oneonta.mp3',
      description: 'The county seat of Blount County, known for its Covered Bridge Festival.'
    },
    {
      word: 'Pintlala',
      phonetic: 'Pent-la-la',
      // audioUrl: '/audio/pintlala.mp3',
      description: 'An unincorporated community named for Pintlala Creek.'
    },
    {
      word: 'Sylacauga',
      phonetic: 'Sill-uh-caw-guh',
      // audioUrl: '/audio/sylacauga.mp3',
      description: 'Nicknamed "The Marble City" and "Alabama’s Best-Kept Secret."'
    },
    {
      word: 'Tallassee',
      phonetic: 'Tae-luh-see',
      // audioUrl: '/audio/tallassee.mp3',
      description: 'Often confused with Tallahassee, Fla., but pronounced without "hass."'
    },
    {
      word: 'Wedowee',
      phonetic: 'Wee-DOW-ee',
      // audioUrl: '/audio/wedowee.mp3',
      description: 'A town named for a Muscogee Creek Indian chief, meaning "old water."'
    }
  ]
};